<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Onboarding Screen UA 2.0</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Create New</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <b-card class="text-center bg-gray-100">
            <b-row>
              <b-col>
                <img v-if="url" width="100%" height :src="url" />
              </b-col>
            </b-row>
            <input
              type="file"
              ref="file"
              style="display: none"
              v-validate="'required|image|minimalDimensions:720,668|size:2000|ext:jpg,png,gif,jpeg'"
              name="image"
              @change="onChangeFileUpload()"
            />
            <br />
            <b-link
              @click="$refs.file.click()"
              v-show="!file"
              variant="primary"
              class="text-primary btn"
            >
              <img class="mr-2" src="@/assets/ic-plus.svg" alt /> Select Image Here
              <label class="text-danger">*</label>
            </b-link>
            <b-button @click="$refs.file.click()" v-show="file" variant="outline-primary" class>
              <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
            </b-button>
            <br />
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('image') }}</p>
            <p class="text-gray-500">
              Ukuran gambar 720x668 pixel
              File gambar harus berupa format JPEG, PNG, atau GIF
              Gambar tidak boleh melebihi 2MB
            </p>
          </b-card>
          <br />
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>

        <b-col md="8">
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Title Bahasa"
                label-for="input-1"
              >
                <input
                  id="input-1"
                  type="text"
                  class="form-control"
                  v-validate="'required|max:25'"
                  name="title_id"
                  data-vv-as="Title Bahasa"
                  v-model="title_id"
                  placeholder="Title"
                />
                <b-form-invalid-feedback
                  id="input-title_id-feedback"
                >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Title English"
                label-for="input-1"
              >
                <input
                  id="input-1"
                  type="text"
                  class="form-control"
                  v-validate="'required|max:25'"
                  name="title_en"
                  data-vv-as="Title English"
                  v-model="title_en"
                  placeholder="Title"
                />
                <b-form-invalid-feedback
                  id="input-title_en-feedback"
                >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Content Bahasa"
                label-for="input-1"
              >
                <ckeditor
                  :editor="editor"
                  :config="editorConfig"
                  v-model="content_id"
                  v-validate="'required|max:200'"
                  name="content_id"
                  data-vv-as="Content Bahasa"
                  tag-name="textarea"
                  placeholder="Content Bahasa"
                  class="form-control"
                ></ckeditor>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('content_id') }}</p>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Content English"
                label-for="input-1"
              >
                <ckeditor
                  :editor="editor"
                  :config="editorConfig"
                  v-model="content_en"
                  v-validate="'required|max:200'"
                  name="content_en"
                  data-vv-as="Content English"
                  tag-name="textarea"
                  placeholder="Content English"
                  class="form-control"
                ></ckeditor>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('content_en') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Slide Screen"
                label-for="input-1"
              >
                <b-form-select
                  v-model="slide"
                  v-validate="'required'"
                  name="slide"
                  data-vv-as="Slide Screen"
                  class="mb-3"
                >
                  <option :value="null">Please select an slide number</option>
                  <option
                    v-for="slide in slide_screen"
                    :key="slide"
                    :value="slide.slide_screen"
                    :disabled="slide.is_available == false"
                    :class="slide.is_available == false ? 'text-danger':''"
                  >{{slide.slide_screen}}</option>
                </b-form-select>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('slide') }}</p>
                <div
                  class="text-danger"
                  id="input-content_id-feedback"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                  v-for="slide in slide_screen"
                  :key="slide"
                >
                  <label v-show="slide.message != ''">Screen {{slide.slide_screen}} already used in</label>
                  <li v-show="message" v-for="message in slide.message" :key="message">{{message}}</li>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-group id="fieldset-1" label="Start Date" label-for="input-1">
                <b-row class="m-0">
                  <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      @input="getSlideScreen()"
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="period_start"
                      :format="customFormatter"
                      :disabledDates="disabledDates"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetStardate" style="text-decoration:none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="fieldset-1" label="End Date" label-for="input-1">
                <b-row class="m-0">
                  <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      @input="getSlideScreen()"
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="period_end"
                      :format="customFormatter"
                      :disabledDates="disabledDates"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetEnddate" style="text-decoration:none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
                <br />
                <b-row></b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col>
              <b-button variant="primary" @click="post()" :disabled="loading" class="mr-5">Create</b-button>
              <b-button
                variant="warning"
                @click="modalShow = !modalShow"
                :disabled="!file"
                class="mr-5"
              >Preview</b-button>
              <router-link :to="{name: 'onBoardingScreen'}">
                <b-button variant="outline-secondary">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
          <b-modal v-model="modalShow" hide-footer hide-header title="Preview Image">
            <b-row>
              <b-col>
                <h5 class="font-weight-bold text-dark">Preview</h5>
              </b-col>
            </b-row>
            <br />
            <b-card
              bg-variant="white"
              text-variant="black"
              style="width: 465px; height:800px;"
              class="text-left"
            >
              <b-row>
                <b-col class="text-right">
                  <i class="fas fa-wifi pr-2"></i>
                  <i class="fas fa-signal pr-2"></i>
                  <i class="fas fa-battery-full pr-2"></i>12:00
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-center">
                  <img :src="url" class="mt-5" width="360px" height="334px" alt />
                </b-col>
              </b-row>
              <b-row style="min-height:100px;">
                <b-col>
                  <h1 class="mt-3 text-primary">{{title_id}}</h1>
                </b-col>
              </b-row>
              <b-row style="min-height:100px;">
                <b-col>
                  <h5 class="text-primary" v-html="content_id"></h5>
                </b-col>
              </b-row>
              <b-row class="mt-5 pt-4">
                <b-col class="pt-3">
                  <i class="fas fa-circle text-gray-500 fa-xs mr-3"></i>
                  <i class="fas fa-circle text-gray-500 fa-xs mr-3"></i>
                  <i class="fas fa-circle text-danger mr-3"></i>
                  <i class="fas fa-circle text-gray-500 fa-xs"></i>
                </b-col>
                <b-col class="text-right">
                  <i class="fas fa-arrow-right fa-3x bg-primary text-white px-2 py-2 rounded-circle"></i>
                </b-col>
              </b-row>
            </b-card>
            <br />
            <b-row>
              <b-col align="right">
                <b-button class="py-1 px-4" @click="modalShow=false" variant="outline-primary">OK</b-button>
              </b-col>
            </b-row>
          </b-modal>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},

      loading: false,
      selected: "first",
      checked: false,
      modalShow: false,
      file: "",
      widthImage: null,
      heightImage: null,
      url: "",
      title_id: "",
      title_en: "",
      content_id: "",
      content_en: "",
      slide: null,
      period_start: "",
      period_end: "",
      is_always_active: false,
      is_highlight: false,
      counthighlight: null,
      slide_screen: [],
      status: [
        { text: "Active", value: "first" },
        { text: "Inactive", value: "second" }
      ],
      button: [
        { text: "No", value: "first" },
        { text: "Yes", value: "second" }
      ],
      options2: [
        { text: "Yes", value: "first" },
        { text: "No", value: "second" }
      ],
      disabledDates: {
        to: new Date(Date.now() - 8672000)
      }
    };
  },
  beforeCreate() {
    const formData = new FormData();
    formData.append("period_start", "");
    formData.append("period_end", "");
    this.$store.dispatch("OnBoardingScreenModule/getSlideScreen", formData);
  },
  created() {
    this.$store.watch(
      state => state.OnBoardingScreenModule.slide_screen,
      (newValue, oldValue) => {
        this.slide_screen = newValue;
      }
    );
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getSlideScreen() {
      const formData = new FormData();
      if (this.period_start != "" && this.period_end == "") {
        const start = this.period_start.toJSON().slice(0, 10);
        formData.append("period_start", start);
        formData.append("period_end", this.period_end);
      }
      if (this.period_end != "" && this.period_start == "") {
        const end = this.period_end.toJSON().slice(0, 10);
        formData.append("period_start", this.period_start);
        formData.append("period_end", end);
      }
      if (this.period_start != "" && this.period_end != "") {
        const start = this.period_start.toJSON().slice(0, 10);
        const end = this.period_end.toJSON().slice(0, 10);

        formData.append("period_start", start);
        formData.append("period_end", end);
      }
      if (this.period_start == "" && this.period_end == "") {
        formData.append("period_start", this.period_start);
        formData.append("period_end", this.period_end);
      }
      this.$store.dispatch("OnBoardingScreenModule/getSlideScreen", formData);
    },
    resetStardate() {
      this.period_start = "";
      const formData = new FormData();
      if (this.period_start != "" && this.period_end == "") {
        const start = this.period_start.toJSON().slice(0, 10);
        formData.append("period_start", start);
        formData.append("period_end", this.period_end);
      }
      if (this.period_end != "" && this.period_start == "") {
        const end = this.period_end.toJSON().slice(0, 10);
        formData.append("period_start", this.period_start);
        formData.append("period_end", end);
      }
      if (this.period_start != "" && this.period_end != "") {
        const start = this.period_start.toJSON().slice(0, 10);
        const end = this.period_end.toJSON().slice(0, 10);

        formData.append("period_start", start);
        formData.append("period_end", end);
      }
      if (this.period_start == "" && this.period_end == "") {
        formData.append("period_start", this.period_start);
        formData.append("period_end", this.period_end);
      }
      this.$store.dispatch("OnBoardingScreenModule/getSlideScreen", formData);
    },
    resetEnddate() {
      const formData = new FormData();
      if (this.period_start != "" && this.period_end == "") {
        const start = this.period_start.toJSON().slice(0, 10);
        formData.append("period_start", start);
        formData.append("period_end", this.period_end);
      }
      if (this.period_end != "" && this.period_start == "") {
        const end = this.period_end.toJSON().slice(0, 10);
        formData.append("period_start", this.period_start);
        formData.append("period_end", end);
      }
      if (this.period_start != "" && this.period_end != "") {
        const start = this.period_start.toJSON().slice(0, 10);
        const end = this.period_end.toJSON().slice(0, 10);

        formData.append("period_start", start);
        formData.append("period_end", end);
      }
      if (this.period_start == "" && this.period_end == "") {
        formData.append("period_start", this.period_start);
        formData.append("period_end", this.period_end);
      }
      this.$store.dispatch("OnBoardingScreenModule/getSlideScreen", formData);
      this.period_end = "";
    },
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const formData = new FormData();

          formData.append("title_id", this.title_id);
          formData.append("title_en", this.title_en);
          formData.append("content_id", this.content_id);
          formData.append("content_en", this.content_en);
          formData.append("slide_screen", this.slide);
          formData.append("image", this.file);
          if (this.period_start != "" && this.period_end == "") {
            const start = this.period_start.toJSON().slice(0, 10);
            formData.append("period_start", start);
            formData.append("period_end", this.period_end);
          }
          if (this.period_end != "" && this.period_start == "") {
            const end = this.period_end.toJSON().slice(0, 10);
            formData.append("period_start", this.period_start);
            formData.append("period_end", end);
          }
          if (this.period_start != "" && this.period_end != "") {
            const start = this.period_start.toJSON().slice(0, 10);
            const end = this.period_end.toJSON().slice(0, 10);

            formData.append("period_start", start);
            formData.append("period_end", end);
          }
          if (this.period_start == "" && this.period_end == "") {
            formData.append("period_start", this.period_start);
            formData.append("period_end", this.period_end);
          }

          this.loading = true;
          this.$store
            .dispatch("OnBoardingScreenModule/postOnBoardingScreen", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "onBoardingScreen" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your file cant be submit.", "warning");
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
